import { render, staticRenderFns } from "./child_email_si_title.vue?vue&type=template&id=40b9ff8c&scoped=true&"
import script from "./child_email_si_title.vue?vue&type=script&lang=js&"
export * from "./child_email_si_title.vue?vue&type=script&lang=js&"
import style0 from "./child_email_si_title.vue?vue&type=style&index=0&id=40b9ff8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9ff8c",
  null
  
)

export default component.exports